import { authGet } from '../../utils/authFetch';
import { wmServerAddress } from '../../common/MetaSetting';
import { fetchHttpResponseHandler } from '../../util/UtilFunction';
import { UIMemoIndex } from '../../model/UiShapes';
import { handleError } from '../managers/errorHandler';

// 数据转换函数 - 将API返回的MemoIndex数据转换为UIMemoIndex类型
export function convertToUIMemoIndex(memoIndexData: any): UIMemoIndex | null {
  if (!memoIndexData) {
    return null;
  }

  try {
    const uiMemoIndex: UIMemoIndex = {
      createTimestamp: memoIndexData.createTimestamp || 0,
      modifyTimestamp: memoIndexData.modifyTimestamp || 0,
      stateCode: memoIndexData.stateCode || 1,
      content: memoIndexData.content || '',
      guid: memoIndexData.guid || ''
    };

    if (memoIndexData.content) {
      try {
        let contentData: any;
        
        if (typeof memoIndexData.content === 'string') {
          contentData = JSON.parse(memoIndexData.content);
        } else if (typeof memoIndexData.content === 'object') {
          contentData = memoIndexData.content;
        } else {
          contentData = {};
        }
        
        if (contentData.indexes && Array.isArray(contentData.indexes)) {
          uiMemoIndex.indexes = contentData.indexes.map((indexItem: any) => ({
            label: indexItem.label || '',
            level: indexItem.level || ''
          }));
        }
        
      } catch (parseError) {
      }
    }
    
    if (uiMemoIndex.guid) {
      return uiMemoIndex;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

// 批量转换函数 - 将API返回的MemoIndex数组转换为UIMemoIndex数组
export function convertToUIMemoIndexes(memoIndexesData: any[]): UIMemoIndex[] {
  
  if (!Array.isArray(memoIndexesData)) {
    return [];
  }
  
  const convertedIndexes = memoIndexesData
    .map((memoIndexData, index) => {
      return convertToUIMemoIndex(memoIndexData);
    })
    .filter((memoIndex): memoIndex is UIMemoIndex => memoIndex !== null);

  return convertedIndexes;
}

// 获取所有的memo indexes
export async function fetchAllMemoIndexes(): Promise<UIMemoIndex[] | null> {
  try {
    const response = await authGet(`${wmServerAddress}/index/all`);
    const processedResponse = await fetchHttpResponseHandler(response);
    
    if (!processedResponse) {
      return null;
    }

    if (processedResponse.content) {
      if (processedResponse.content.memoIndexes && Array.isArray(processedResponse.content.memoIndexes)) {
        const memoIndexes = convertToUIMemoIndexes(processedResponse.content.memoIndexes);
        return memoIndexes;
      }
      
      if (Array.isArray(processedResponse.content)) {
        const memoIndexes = convertToUIMemoIndexes(processedResponse.content);
        return memoIndexes;
      }
      
      if (typeof processedResponse.content === 'object' && processedResponse.content.memoIndexes && Array.isArray(processedResponse.content.memoIndexes)) {
        const memoIndexes = convertToUIMemoIndexes(processedResponse.content.memoIndexes);
        return memoIndexes;
      }
      
      if (typeof processedResponse.content === 'object') {
        const memoIndex = convertToUIMemoIndex(processedResponse.content);
        return memoIndex ? [memoIndex] : null;
      }
    }
    
    if (Array.isArray(processedResponse)) {
      const memoIndexes = convertToUIMemoIndexes(processedResponse);
      return memoIndexes;
    }
    
    if (typeof processedResponse === 'object') {
      const memoIndex = convertToUIMemoIndex(processedResponse);
      return memoIndex ? [memoIndex] : null;
    }

    return null;
  } catch (error) {
    return null;
  }
}

// 根据guid获取特定的memo index
export async function fetchMemoIndex(memoId: string): Promise<UIMemoIndex | null> {
  if (!memoId) {
    return null;
  }
  
  try {
    handleError(new Error(`fetchMemoIndex: 开始获取memo ${memoId} 的index`), { context: 'memoIndexAPI', showToast: false });
    const response = await authGet(`${wmServerAddress}/index/${memoId}`);
    const processedResponse = await fetchHttpResponseHandler(response);
    
    if (!processedResponse) {
      return null;
    }
    
    const memoIndex = convertToUIMemoIndex(processedResponse);
    
    return memoIndex;
  } catch (error) {
    return null;
  }
}



// Query keys
export const memoIndexKeys = {
  all: ['memoIndexes'] as const,
  lists: () => [...memoIndexKeys.all, 'list'] as const,
  list: () => [...memoIndexKeys.lists()] as const,
  details: () => [...memoIndexKeys.all, 'detail'] as const,
  detail: (memoId: string) => [...memoIndexKeys.details(), memoId] as const, // 统一使用memoId作为参数，与TAG保持一致
  memoIndexes: (memoId: string) => [...memoIndexKeys.all, 'memo', memoId] as const,
};